import React, { FC, useMemo, useState } from 'react'
import { VStack, Textarea, Box, Image, Flex, Text } from '@chakra-ui/react'
import { Button, Icon } from '../../components'
import theme from '../../styles'
import { useSelector } from 'react-redux'
import { selectScenario } from '../../state'
import { cardImageMap, ScenarioType } from '../../state/interfaces'
import { useTranslation } from 'react-i18next'
import { CheckboxConfirm } from '../checkboxes/checkbox-confirm'

export interface SelectProps {
  placeholder?: string
  onChange?: (values: string[]) => void
  name: string
  grandImage?: string
}

export const TextareaDefault: FC<SelectProps> = ({ placeholder, onChange, name, grandImage }) => {
  const [textareaValue, setTextareaValue] = React.useState('')
  const image = useMemo(() => (grandImage ? cardImageMap[grandImage] : ''), [grandImage])

  const handleInputChange = (event: any) => {
    setTextareaValue(event.target.value)
  }

  const scenario = useSelector(selectScenario)
  const { t } = useTranslation()

  // const [selectedChoices, setSelectedChoices] = useState<string[]>([])
  const [isConfirmedNewsLetter, setIsConfirmedNewsLetter] = useState(false)

  const handleCheckboxChange = (value: string, checked: boolean) => {
    setIsConfirmedNewsLetter(checked)
  }

  const handleOnClick = () => {
    if (isConfirmedNewsLetter) {
      onChange && onChange([textareaValue, 'confirm-newsletters'])
    }
    onChange && onChange([textareaValue])
  }

  const isB2BScenario = scenario && scenario.type === ScenarioType.B2B

  return (
    <VStack spacing={4} marginY={8} gridRowGap={4}>
      <Flex
        direction={!isB2BScenario ? 'column' : undefined}
        marginY={3}
        maxW={!isB2BScenario ? { md: 600 } : undefined}
      >
        <Textarea
          value={textareaValue}
          onChange={handleInputChange}
          placeholder={placeholder}
          variant="none"
          height={!isB2BScenario ? 170 : 70}
          name={name}
          size="lg"
          border="2px solid"
          borderColor="grey"
          backgroundColor="transparent"
          _placeholder={{ color: 'green.500', fontStyle: 'italic', fontSize: '16px' }}
          fontSize={14}
          autoFocus
          maxLength={950}
          onClick={(e) => {
            e.stopPropagation()
            e.currentTarget.focus()
          }}
          width={isB2BScenario ? { md: '30vw' } : undefined}
          marginLeft={isB2BScenario ? 'auto' : undefined}
          marginRight={isB2BScenario ? 'auto' : undefined}
        />
        {!isB2BScenario && (
          <label>
            <Box backgroundColor="#e8e8e8" borderRadius={6} mt={4}>
              <Box display="flex" width="100%" paddingX={6} paddingY={2}>
                <Flex alignItems="center" minW={{ base: 120, md: 200 }}>
                  <Flex border="1px solid lightgrey" alignItems="center" mt={1} minW={'18px'} zIndex={2}>
                    <CheckboxConfirm value="confirm-newsletters" onChange={handleCheckboxChange} />
                  </Flex>
                  <Text ml={4} whiteSpace="normal" cursor="pointer" fontSize={{ base: '14', md: '16' }}>
                    <strong>{t('optional-confirmation-title')}</strong>
                    <br />
                    {t('optional-confirmation-text')}
                  </Text>
                </Flex>
              </Box>
            </Box>
          </label>
        )}
      </Flex>
      <Button
        role={'button'}
        layerStyle={theme.LayerStyles.SMALL_PILL}
        onClick={() => {
          handleOnClick()
        }}
      >
        {scenario!.type === ScenarioType.TICKET ? (
          <Box color="white" fontSize={16}>
            {t('create-issue')}
          </Box>
        ) : scenario!.type === ScenarioType.B2B ? (
          <Box color="white" fontSize={16}>
            {t('common_next')}
          </Box>
        ) : (
          <Icon icon="arrow-right" color="white" />
        )}
      </Button>
      {image && <Image src={image} alt="image" width={['0', '150px']} height={['0', '150px']} />}
    </VStack>
  )
}
